import { Tabs, TabsList, TabsTrigger } from '@/components/ui';
import { Link, useLocation } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks';
import routes from '@/lib/routes';

const TabMenus = () => {

  const { pathname } = useLocation();

  const tabSelected = pathname.split('/').reverse()[0];

  useDocumentTitle({
    title: (
      tabSelected === 'overview'
        ? `Vue d'ensemble comptabilité`
          : tabSelected === 'users'
            ? `Utilisateurs comptables`
            : 'Transactions en comptabilité'
    )
  });

  return (
    <Tabs className='pt-3 md:pt-5' value={tabSelected}>
      <TabsList className='w-full flex md:w-auto md:inline-flex'>
        <TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='overview'>
          <Link replace to={routes.nav.accounting.overview.path}>
            Vue d'ensemble
          </Link>
        </TabsTrigger>
        <TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='transactions'>
          <Link replace to={routes.nav.accounting.transactions.getHref()}>
            Transactions
          </Link>
        </TabsTrigger>
        <TabsTrigger asChild className='flex-1 md:flex-none px-2 md:px-3 text-[12px] md:text-sm' value='users'>
          <Link replace to={routes.nav.accounting.users.getHref()}>
            Utilisateurs
          </Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );

};

export default TabMenus;
